// import axios from 'axios';
import React, { useState } from 'react';
import './InputData.styl';

function InputData_MB(props) {
  return (
    <div className="data-customization-external-geojson-form">

      <div className="data-customization-panel__input__container">
        <input
          type="text"
          value={props.dataURL_MB}
          onChange={e => props.setDataURL_MB(e.target.value)}
          className="data-customization-panel__input"
          placeholder={props.placeholder}
        />
      </div>
    
    </div>
  )
}
export default InputData_MB